import React from "react";
import { Link } from "react-router-dom";
import JsonData from "../data/data.json";
import { Seo } from "../components/Seo";
import { BreadcrumbLd } from "../components/BreadcrumbLd";
import { usePrecios } from "../hooks/usePrecios";
const euros = (n) =>
  new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);

export default function Cumpleanos() {
  const { precios, error: preciosError } = usePrecios();
  const data = JsonData.Cumpleanos || {};
  const preciosCumpleanos = precios?.Cumpleanos || {};
  const extras = preciosCumpleanos.extras || [];

  return (
    <div className="container" style={{ paddingTop: 10, paddingBottom: 60 }}>
      <Seo
        title="Fiestas y cumpleaños | Celebra en la hípica"
        description="Organizamos cumpleaños y eventos infantiles con ponis y actividades ecuestres en un entorno natural."
        path="/cumpleanos"
        image="https://madridcampogrande.es/og/default.jpg"
      />
      <BreadcrumbLd
        items={[
          { name: "Inicio", path: "/" },
          { name: "Fiestas y cumpleaños", path: "/cumpleanos" },
        ]}
      />

      <h1 className="text-center" style={{ marginBottom: 20 }}>
        {data.titulo}
      </h1>

      {/* Lema */}
      {data.lema && (
        <h2 className="text-center" style={{ marginBottom: 20 }}>
          {data.lema}
        </h2>
      )}

      {/* Intro */}
      {data.intro && <p style={{ lineHeight: 1.7 }}>{data.intro}</p>}

      {/* Imagen 1 */}
      {data.imagenes?.[0] && (
        <div style={{ margin: "30px 0" }}>
          <img
            src={data.imagenes[0].src}
            alt={data.imagenes[0].alt}
            className="img-responsive img-thumbnail"
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      )}

      {/* Instalaciones */}
      {Array.isArray(data.instalaciones) && (
        <>
          <h3>Las instalaciones incluyen:</h3>
          <ul>
            {data.instalaciones.map((it, i) => (
              <li key={i}>{it}</li>
            ))}
          </ul>
        </>
      )}

      <p>Podrás montar, jugar, merendar y pasarlo muy bien.</p>

      {/* Imagen 2 */}
      {data.imagenes?.[1] && (
        <div style={{ margin: "30px 0" }}>
          <img
            src={data.imagenes[1].src}
            alt={data.imagenes[1].alt}
            className="img-responsive img-thumbnail"
          />
        </div>
      )}

      {/* Precios */}
      <section aria-labelledby="precios" style={{ marginTop: 25 }}>
        <h3 id="precios">Precios</h3>
        {preciosError && (
          <div className="alert alert-warning">
            No se han podido cargar los precios en este momento.
          </div>
        )}
        {!precios && !preciosError && <p>Cargando precios...</p>}
        {preciosCumpleanos.precio && (
          <p>
            <strong>{euros(preciosCumpleanos.precio)}</strong> por niño
          </p>
        )}

        {Array.isArray(data.incluye) && (
          <>
            <h4>Estos precios incluyen:</h4>
            <ul>
              {data.incluye.map((it, i) => (
                <li key={i}>{it}</li>
              ))}
            </ul>
          </>
        )}
      </section>

      {/* Imagen 3 */}
      {data.imagenes?.[2] && (
        <div style={{ margin: "30px 0" }}>
          <img
            src={data.imagenes[2].src}
            alt={data.imagenes[2].alt}
            className="img-responsive img-thumbnail"
          />
        </div>
      )}

      {/* Extras */}
      {extras.length > 0 && (
        <>
          <h4>Extras y opciones</h4>
          <ul>
            {extras.map((it, i) => (
              <li key={i}>{it}</li>
            ))}
          </ul>
        </>
      )}

      {/* Imagen 4 */}
      {data.imagenes?.[3] && (
        <div style={{ margin: "30px 0" }}>
          <img
            src={data.imagenes[3].src}
            alt={data.imagenes[3].alt}
            className="img-responsive img-thumbnail"
          />
        </div>
      )}

      {/* Seguridad */}
      {data.seguridad && (
        <div className="alert alert-info" style={{ marginTop: 15 }}>
          {data.seguridad}
        </div>
      )}

      {/* Indumentaria */}
      {Array.isArray(data.indumentaria) && (
        <>
          <h3 style={{ marginTop: 25 }}>Indumentaria recomendada</h3>
          <ul>
            {data.indumentaria.map((it, i) => (
              <li key={i}>{it}</li>
            ))}
          </ul>
        </>
      )}


      <div style={{ marginTop: 25 }}>
        <Link to="/contacto" className="btn btn-primary">
          Reservar o pedir información
        </Link>
      </div>
    </div>
  );
}
